<template>
  <Pie
    :chart-id="'pieChart'"
    :options="chartOptions"
    :data="chartData"
    :plugins="plugins"
  />
</template>

<script>
  import { Pie } from 'vue-chartjs';
  import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale, Colors } from 'chart.js';
  import ChartDataLabels from 'chartjs-plugin-datalabels';

  ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale, Colors);
  export default {
    name: 'PieChart',
    components: { Pie },
    props: ['data'],
    data: () => ({
      bgColor: {
        id: 'customCanvasBackgroundColor',
        beforeDraw: (chart, _args, options) => {
          const { ctx } = chart;
          ctx.save();
          ctx.globalCompositeOperation = 'destination-over';
          ctx.fillStyle = options.color || 'white';
          ctx.fillRect(0, 0, chart.width, chart.height);
          ctx.restore();
        },
      },
    }),

    computed: {
      chartData() {
        return {
          labels: this.data.labels,
          datasets: [
            {
              data: this.data.data,
            },
          ],
        };
      },
      chartOptions() {
        return {
          responsive: true,
          maintainAspectRatio: false,
          animation: false,
          plugins: {
            colors: {
              forceOverride: true,
            },
            title: {
              display: true,
              text: this.data.title,
              padding: 5,
              fontSize: 44,
            },
            datalabels: {
              display: true,
              formatter: (val, ctx) => {
                const label = ctx.chart.data.labels[ctx.dataIndex];

                return `${label}: ${val}`;
              },
              color: '#fff',
              backgroundColor: '#404040',
            },
          },
        };
      },
      plugins() {
        const { bgColor } = this;
        return [ChartDataLabels, bgColor];
      },
    },
  };
</script>
